var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title",style:(("\n    padding-left: " + (_vm.indent ? 20 : 0) + "px;\n    margin-bottom: " + (_vm.marginBottom ? 20 : 0) + "px;\n  "))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }